import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { msalInstance } from '../main';
import axios from 'axios';

export const acquireTokenSilent = async () => {
  const account =
    msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
  const request = {
    scopes: [import.meta.env.VITE_AUTH_AUDIENCE_API],
    account,
  };
  const tokenResponse = await msalInstance
    .acquireTokenSilent(request)
    .catch(async (error) => {
      if (error instanceof InteractionRequiredAuthError) {
        await msalInstance.acquireTokenRedirect(request);
      }
    });
  return tokenResponse;
};

export const getTokenHeaderFromMsal = async () => {
  const tokenResponse = await acquireTokenSilent();
  return tokenResponse?.accessToken as string;
};

export const getAccessToken = () => {
  return `Bearer ${sessionStorage.getItem('accessToken')}`;
};

const loginRequest = {
  scopes: ['User.Read'],
};

export async function getUserPhoto(userId: string) {
  try {
    // Login and acquire token silently or interactively
    const account =
      msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
    const tokenResponse = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account: account,
    });

    const accessToken = tokenResponse.accessToken;

    // Fetch user photo from Microsoft Graph
    const response = await axios.get(
      `https://graph.microsoft.com/v1.0/users/${userId}/photo/$value`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        responseType: 'blob', // Ensure binary response for the image
      }
    );

    const blob = (await response.data) as Blob;
    // const imageUrl = URL.createObjectURL(blob);

    await acquireTokenSilent();

    return blob; // Use this URL to display the image
  } catch (error) {
    //@ts-ignore
    if (error.response?.status === 404) {
      console.warn('No profile photo found for the user.');
      return null; // Fallback to a default image
    } else {
      console.error('Error fetching user photo:', error);
    }
  }
}
